const zoneApplicants = {
  assignApplicants: "Assign Applicant",
  assignSupervisor: "Assign Supervisor",
  changeSupervisor: "Change Supervisor",
  supervisor: "Supervisor",
  applicants: "Applicants",
  search: "Search by Name/ID",
  staffApplicant: "Staff / Applicant",
  rating: "Rating",
  action: "Action",
  unassign: "Unassign",
  applicantsRole: "Applicant's role",
  allRoles: "All Roles",
  /** {count} = how many applicants are ticked in the assign modal */
  selectedCount: "{count} selected",
  /** {role} = the role the applicant applied with */
  applicantRole: "Role: {role}",
  assignSelected: "Assign Selected",
  changeRole: "Change Role",
  showingRange: "Showing {from}-{to} of {total} applicants",
  unassignModal: {
    title: "Confirm un-assignment",
    unassignConfirmationMsg:
      "Are you sure you want to unassign this applicant from their zone?",
    zoneWillBeCleared: "Zone will be cleared",
    statusChange: "Allocation status: Assigned → Unassigned",
    /** {count} = how many applicants were unassigned */
    successTitle: "{count} users have been unassigned from the zone successfully.",
    successTitleSingle:
      "1 user has been unassigned from the zone successfully.",
    successZoneCleared: "Zone updated to unassigned",
  },
  unassignSupervisor: "Unassign Supervisor",
  unassignSupervisorModal: {
    title: "Confirm un-assignment",
    confirmationMsg:
      "Are you sure you want to unassign this Supervisor from their zone?",
    warningTitle: "Zone will have no supervisor",
    warningDescription: "Applicants assigned to this zone stay assigned.",
    success: "Supervisor has been unassigned from the zone successfully.",
  },
  assignModal: {
    title: "Assign zone applicants",
    /** {count} = how many applicants were assigned */
    successTitle: "{count} applicants have been assigned to the zone successfully.",
    successTitleSingle: "1 applicant has been assigned to the zone successfully.",
  },
  supervisorModal: {
    assignTitle: "Assign Supervisor",
    changeAndSave: "Change and Save",
    replacing: "Replacing",
    noAvailableSupervisor: "No Available Supervisor",
    assignSuccess: "Supervisor has been assigned to the zone successfully.",
  },
  emptyState: {
    title: "No applicants in this zone",
    description: "Assign approved applicants to start staffing this zone.",
  },
  allAssigned: {
    title: "All applicants are already assigned",
    /** {role} = the selected role filter */
    description:
      "Everyone matching {role} for this event is already in a zone. Change the role filter or check the zone's applicant list.",
  },
  filteredEmptyState: {
    title: "No matching applicants",
    description: "Try a different search term or clear the filters.",
  },
  notAssigned: "Not assigned yet",
};

export default zoneApplicants;
